document.addEventListener("DOMContentLoaded",function () {
  (function ($) {
    $("a[href^='#nav\\[']").each(function() {
      var href = $(this).attr('href');
      var navFunction = href.match(/(?:'[^']*'|^[^']*$)/)[0].replace(/'/g, "");
      if (AFCS.fn.nav.hasOwnProperty(navFunction)) {
        href = "javascript:AFCS.fn.nav." + navFunction + "()";
      }
      $(this).attr('href', href);
    });
    $('header').css('display', 'flex');
    $('footer').css('display', 'block');
    window.AFCS = AFCS;
  })(jQuery);
});

var AFCS = {};
AFCS.fn = {};
AFCS.fn.nav = {};

AFCS.fn.docReady = function(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
};

AFCS.fn.nav.isSearchOpen = function() {
  return document.body.classList.contains('search-open');
}

AFCS.fn.nav.isSearchClosing = function() {
  return document.body.classList.contains('search-closing');
}

AFCS.fn.nav.isSocialOpen = function() {
  return document.body.classList.contains('social-open');
}

AFCS.fn.nav.isSocialClosing = function() {
  return document.body.classList.contains('social-closing');
}

AFCS.fn.nav.toggleSocial = function() {
  var isOpen = document.body.classList.contains('social-open');
  if (isOpen) {
    return;
  } else {
    document.body.classList.remove('search-open');
    document.body.classList.add('social-open');
  }
}

AFCS.fn.nav.toggleSearch = function() {
  var isOpen = document.body.classList.contains('search-open');
  if (isOpen) {
    return;
  } else {
    document.body.classList.remove('social-open');
    document.body.classList.add('search-open');
  }
}

AFCS.fn.nav.toggleClose = function() {
  if (AFCS.fn.nav.isSearchOpen()) {
    document.body.classList.add('search-closing');
    document.body.classList.remove('search-open');
    setTimeout(function() {
      document.body.classList.remove('search-closing');
    }, 300);
  }
  if (AFCS.fn.nav.isSocialOpen()) {
    document.body.classList.add('social-closing');
    document.body.classList.remove('social-open');
    setTimeout(function() {
      document.body.classList.remove('social-closing');
    }, 300);
  }
}

AFCS.fn.nav.isMobileMenuActive = function() {
  return document.body.classList.contains('mobile-menu-active');
}

AFCS.fn.nav.toggleMobileMenu = function() {
  if (AFCS.fn.nav.isMobileMenuActive()) {
    document.body.classList.remove('mobile-menu-active');
  } else {
    document.body.classList.add('mobile-menu-active');
  }
}

AFCS.fn.nav.setNavLoaded = function() {
  document.body.classList.add('nav-loaded');
}

AFCS.fn.nav.unsetNavLoaded = function() {
  document.body.classList.remove('nav-loaded');
}

AFCS.fn.docReady(function() {
  var mainNavEl = document.querySelector('.v2-header #main-nav');
  var lineEl = document.querySelector('.v2-header .line');

  function setLineActive(el = null) {
    var elSpan = !el ? document.querySelector('.v2-header #main-nav li.active span') : el;
    var elWidth = elSpan.offsetWidth;
    var elRight = mainNavEl.getBoundingClientRect().right - elSpan.getBoundingClientRect().right;
    lineEl.style.width = elWidth + 'px';
    lineEl.style.right = elRight + 'px';
  }

  mainNavEl.addEventListener('mouseover', function(e) {
    e.stopPropagation();
    if (AFCS.fn.nav.isSocialOpen() || AFCS.fn.nav.isSearchOpen() || AFCS.fn.nav.isSearchClosing() || AFCS.fn.nav.isSocialClosing()) {
      setLineActive();
      return;
    }
    if (e.target.tagName === 'SPAN') {
      setLineActive(e.target);
    }
    if (e.target.tagName === 'A') {
      setLineActive(e.target.querySelector('span'));
    }
    if (e.target.tagName === 'UL') {
      setLineActive();
    }
  });

  mainNavEl.addEventListener('mouseleave', function(e) {
    e.stopPropagation();
    if (AFCS.fn.nav.isSocialOpen() || AFCS.fn.nav.isSearchOpen() || AFCS.fn.nav.isSearchClosing() || AFCS.fn.nav.isSocialClosing()) {
      setLineActive();
      return;
    }
    if (e.target.tagName === 'UL') {
      setLineActive();
    }
  });

  setTimeout(function() {
    setLineActive();
    AFCS.fn.nav.setNavLoaded();
  }, 300);

  document.body.onresize = function() {
    AFCS.fn.nav.unsetNavLoaded();
    setTimeout(function() {
      setLineActive();
      AFCS.fn.nav.setNavLoaded();
    }, 300);
  }

});